// name debe coincidir con el campo "genre" de los libros (seed_data.py)
// Íconos ilustrados (PNG transparentes) en /public/genres
export const GENRES = [
  { name: "Aventura", img: "/genres/aventura.png", color: "#8B5CF6", bg: "#EDE9FE" },
  { name: "Misterio y suspenso", img: "/genres/misterio.png", color: "#F59E0B", bg: "#FEF3C7" },
  { name: "Romance", img: "/genres/romance.png", color: "#EC4899", bg: "#FCE7F3" },
  { name: "Cuentos infantiles", img: "/genres/infantiles.png", color: "#F97316", bg: "#FFEDD5" },
  { name: "Realismo", img: "/genres/realismo.png", color: "#0EA5E9", bg: "#E0F2FE" },
  { name: "Ciencia ficción", img: "/genres/scifi.png", color: "#6366F1", bg: "#E0E7FF" },
  { name: "Poesía", img: "/genres/poesia.png", color: "#F59E0B", bg: "#FEF3C7" },
  { name: "Historia", img: "/genres/historia.png", color: "#0EA5E9", bg: "#E0F2FE" },
  { name: "Literatura clásica", img: "/genres/clasica.png", color: "#EC4899", bg: "#FCE7F3" },
];

export const GENRE_STYLE = GENRES.reduce((acc, g) => {
  acc[g.name] = { color: g.color, bg: g.bg };
  return acc;
}, {});
